module.exports = __webpack_public_path__ + "static/media/centered-logo-white.adbd6719.png";